import React from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from 'common/helmets/Helmet';

const Title = 'GiveButter Case Study | Canny';
const Description =
  'Read about how GiveButter crushed their NPS and predicted the future with Canny';
const Image = 'https://canny.io/images/167803ef4cd8fc9272d25c5f55eb1694.jpg';
const GivebutterUrl = 'https://canny.io/case-studies/givebutter';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${GivebutterUrl}#webpage`,
    url: GivebutterUrl,
    name: 'Case Study: GiveButter × Canny',
    description: 'How GiveButter crushed their NPS and predicted the future with Canny.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${GivebutterUrl}#article`,
    genre: 'Case Study',
    headline: 'How GiveButter crushed their NPS and predicted the future with Canny',
    description:
      "GiveButter adopted Canny to centralize user and team feedback, driving their product roadmap. Their sales team uses Canny's HubSpot integration to upvote feedback on behalf of prospects, and after launching 'Auctions,' they garnered over 600 votes and saw their NPS rise to 75 in Q1.",
    inLanguage: 'en',
    url: GivebutterUrl,
    mainEntityOfPage: { '@id': `${GivebutterUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'GiveButter', url: 'https://givebutter.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'GiveButter', item: GivebutterUrl },
  ]),
]);

const GiveButterLandingHelmet = () => {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: GivebutterUrl },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}>
      <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
    </Helmet>
  );
};

export default GiveButterLandingHelmet;
